import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";

import "./styles/tokens.css";
import "./styles/god.css";
import GodApp from "./App";
import { captureSessionFromHash } from "./lib/api";

// Capture the operator session handed back in the URL fragment before first render.
captureSessionFromHash();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <GodApp />
    </BrowserRouter>
  </React.StrictMode>
);
